<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.25 2.5H8.75V5H11.25V2.5Z" fill="#777FF6" />
    <path d="M5 2.5H2.5V5H5V2.5Z" fill="#777FF6" />
    <path d="M17.5 2.5H15V5H17.5V2.5Z" fill="#777FF6" />
    <path d="M11.25 8.75H8.75V11.25H11.25V8.75Z" fill="#777FF6" />
    <path d="M5 8.75H2.5V11.25H5V8.75Z" fill="#777FF6" />
    <path d="M17.5 8.75H15V11.25H17.5V8.75Z" fill="#777FF6" />
    <path d="M11.25 15H8.75V17.5H11.25V15Z" fill="#777FF6" />
    <path d="M5 15H2.5V17.5H5V15Z" fill="#777FF6" />
    <path d="M17.5 15H15V17.5H17.5V15Z" fill="#777FF6" />
  </svg>
</template>
<script>
export default {
  name: "ProductionMenuIcon",
};
</script>
